module.exports = __webpack_public_path__ + "static/map-bbec67a1f5ff20d3297cdd0912fb5821.png";